import React, { useEffect, useState } from "react";
import Avatar from "react-avatar";
import { Form, Image } from "react-bootstrap";
import pencilImage from "../../assets/images/editPencil.png";
import moment from "moment";

const C = {
  dark: "#1a3328",
  mid: "#2d5a3d",
  bright: "#3d8c5e",
  border: "#eaf5ec",
  textDk: "#1a2e22",
  textGr: "#5a6e61",
  inputBorder: "#c6deca",
};

const btnSave = {
  backgroundColor: C.bright,
  color: "#fff",
  border: "none",
  borderRadius: 7,
  padding: "0.32rem 1rem",
  fontSize: "0.8rem",
  fontWeight: 600,
  cursor: "pointer",
};

const btnCancel = {
  backgroundColor: "#fdecea",
  color: "#c62828",
  border: "1.5px solid #c62828",
  borderRadius: 7,
  padding: "0.32rem 0.9rem",
  fontSize: "0.8rem",
  fontWeight: 600,
  cursor: "pointer",
};

const btnEdit = {
  background: "none",
  border: "none",
  padding: "2px 4px",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
};

const rowStyle = {
  padding: "0.85rem 1.25rem",
  borderBottom: `1px solid ${C.border}`,
};

const Comment = (props) => {
  const [comment, setComment] = useState({});
  const [commentState, setCommentState] = useState("view");

  useEffect(() => { setComment(props.comment); }, [props]);
  useEffect(() => {}, [comment]);

  if (Object.keys(comment).length === 0) return null;

  // ── New comment (no _id yet) ───────────────────────────────────────────────
  if (!comment["_id"]) {
    return (
      <div style={rowStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "0.6rem" }}>
          <Avatar name={comment.commentByName} round={true} size="32" textSizeRatio={2} />
          <span style={{ fontWeight: 600, fontSize: "0.88rem", color: C.textDk }}>
            {comment.commentByName}
          </span>
        </div>
        <Form.Control
          type="text"
          placeholder="Write a comment…"
          onChange={(e) => {
            var t = JSON.parse(JSON.stringify(comment));
            t["comment"] = e.target.value;
            setComment(t);
          }}
          value={comment.comment}
          style={{ borderRadius: 7, border: `1.5px solid ${C.inputBorder}`, fontSize: "0.88rem", marginBottom: "0.6rem" }}
        />
        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button style={btnSave} onClick={() => props.saveComment(comment)}>✓ Save</button>
          <button style={btnCancel} onClick={() => props.popComment()}>✕ Cancel</button>
        </div>
      </div>
    );
  }

  // ── View mode ─────────────────────────────────────────────────────────────
  if (commentState === "view") {
    return (
      <div style={rowStyle}>
        <div style={{ display: "flex", alignItems: "flex-start", gap: "0.75rem" }}>
          <Avatar name={comment.commentBy.fullName} round={true} size="32" textSizeRatio={2} />
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 2 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <span style={{ fontWeight: 700, fontSize: "0.85rem", color: C.textDk }}>
                  {comment.commentBy.fullName}
                </span>
                <span style={{ fontSize: "0.7rem", color: C.textGr }}>
                  {moment(comment.createdAt).fromNow()}
                </span>
              </div>
              {comment.commentBy.fullName === JSON.parse(localStorage.getItem("user")).fullName && (
                <button style={btnEdit} onClick={() => setCommentState("edit")}>
                  <Image src={pencilImage} height="15" />
                </button>
              )}
            </div>
            <p style={{ margin: 0, fontSize: "0.88rem", color: C.textDk, lineHeight: 1.5 }}>
              {comment.comment}
            </p>
          </div>
        </div>
      </div>
    );
  }

  // ── Edit mode ─────────────────────────────────────────────────────────────
  return (
    <div style={rowStyle}>
      <div style={{ display: "flex", alignItems: "flex-start", gap: "0.75rem", marginBottom: "0.6rem" }}>
        <Avatar name={comment.commentBy.fullName} round={true} size="32" textSizeRatio={2} />
        <span style={{ fontWeight: 700, fontSize: "0.85rem", color: C.textDk }}>
          {comment.commentBy.fullName}
        </span>
      </div>
      <Form.Control
        type="text"
        placeholder="Edit comment…"
        onChange={(e) => {
          var t = JSON.parse(JSON.stringify(comment));
          t["comment"] = e.target.value;
          setComment(t);
        }}
        value={comment.comment}
        style={{ borderRadius: 7, border: `1.5px solid ${C.inputBorder}`, fontSize: "0.88rem", marginBottom: "0.6rem" }}
      />
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <button style={btnSave} onClick={() => { props.saveComment(comment); setCommentState("view"); }}>
          ✓ Update
        </button>
        <button style={btnCancel} onClick={() => { props.reloadData(); setCommentState("view"); }}>
          ✕ Cancel
        </button>
      </div>
    </div>
  );
};

export default Comment;
